module.exports = __webpack_public_path__ + "static/img/3.1071061.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/zh/3.png
// module id = YHCF
// module chunks = 0